import styled, { css } from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
    BORDER_PROPERTIES,
    FOCUS_CSS,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';
import { mediaMaxWidth } from 'common/styles/breakpoints';

export const SessionsListBlockContentContainer = styled.div`
    max-width: 770px;
    width: 100%;
    display: grid;
    row-gap: 2rem;

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

const disabledCss = css`
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
`;

const enabledCss = css`
    &:hover {
        background-color: ${(props) => props.$backgroundColorHover};
        color: ${(props) => props.$fontColorHover};
        border-color: ${(props) => props.$borderColorHover};
    }

    &:focus {
        outline-style: auto;
    }

    &:focus-visible {
        outline: 2px solid ${(props) => props.$borderColor};
        outline-offset: 2px;
    }
`;

const RESET_STYLES = css`
    border: none;
    outline-style: none;
    font: inherit;
    background: none;
    cursor: pointer;

    &:focus {
        outline-style: auto;
    }
`;

export const SessionButton = styled.button`
    ${RESET_STYLES}
    display: inline-block;
    padding: 1rem 1rem;
    background-color: ${(props) => props.$backgroundColor};
    white-space: nowrap;
    text-align: center;
    border-style: solid;

    ${FONT_PROPERTIES}
    ${BORDER_PROPERTIES}
    ${FOCUS_CSS}

    ${mediaMaxWidth.medium`
        word-break: break-word;
        white-space: initial;
    `}

    ${(props) => (props.disabled ? disabledCss : enabledCss)}
`;

export const InfoBox = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const InfoBoxMessage = styled.span`
    flex: 1;
`;
